export const hasRole = (user, roleName) =>
    user?.roles?.includes(roleName) ?? false;

export const isAdmin = (user) => hasRole(user, 'ROLE_ADMIN');

export const hasAnyRole = (user, roleNames) =>
    roleNames.some(role => hasRole(user, role));

export const hasAllRoles = (user, roleNames) =>
    roleNames.every(role => hasRole(user, role));
